const apiUrlObj = {
  local: '',
  // development: 'http://10.1.50.41:8080/',
  development: 'https://gateway.wuzheng.com.cn/',
  test: 'https://gateway-test.wuzheng.com.cn/',
  production: 'https://gateway.wuzheng.com.cn/'
}

const aiapiUrlObj = {
  local: '',
  // development: 'http://10.1.50.41:8080/',
  development: 'https://aiapi-test.wuzheng.com.cn',
  test: 'https://aiapi-test.wuzheng.com.cn',
  production: 'https://aiapi.wuzheng.com.cn'
}

const env = process.env.NODE_ENV

export const apiUrl = apiUrlObj[env]

export const aiapiUrl = aiapiUrlObj[env]
